var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0716 5.39286C10.0716 4.76201 9.55959 4.25 8.92873 4.25H8.35731V3.10715C8.35731 1.52943 7.07788 0.25 5.50016 0.25C3.92243 0.25 2.643 1.52943 2.643 3.10715V4.25H2.07157C1.44072 4.25 0.928711 4.76201 0.928711 5.39286V11.1071C0.928711 11.738 1.44072 12.25 2.07157 12.25H8.92873C9.55959 12.25 10.0716 11.738 10.0716 11.1071V5.39286ZM3.78621 3.10821C3.78621 2.16144 4.5537 1.39393 5.5005 1.39393C6.4473 1.39393 7.21479 2.16144 7.21479 3.10821V4.25107H3.78621V3.10821Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.1a923ae17e5d60ad25f63e8d43420fdc.svg";
export { ForwardRef as ReactComponent };